export default (config) => ({
  ...config,
  data: [],
  nodeObject: [],
  editing: false,
  isFetching: true,
  allNodes: [],
  current: {
    bars: [],
    id: null,
    parentId: null,
    contentId: null,
    img: null,
    isLeaf: null,
    icon: null,
    total: null,
    content: {
      id: null,
      type: null,
      title: null,
      description: null
    },
    media: {
      video: {
        volumen: null,
        url: null,
        controls: null,
        styles: {},
        wrapper: 'div'
      }
    }
  },
  parent: {
    bars: [],
    id: null,
    parentId: null,
    contentId: null,
    img: null,
    isLeaf: null,
    icon: null,
    total: null,
    content: {
      id: null,
      type: null,
      title: null,
      description: null
    },
    media: {
      video: {
        volumen: null,
        url: null,
        controls: null,
        styles: {},
        wrapper: 'div'
      }
    }
  },
  emulatedPhoto: 'https://react.semantic-ui.com/assets/images/avatar/large/matthew.png',
  settings: {
    languages: [
      { key: 'es', text: 'Spanish', value: 'spanish' },
      { key: 'en', text: 'English', value: 'english' },
    ],
    tags: [
      {
        textContent: 'Physics',
        color: 'grey'
      },
      {
        textContent: 'Agriculture And Sustainable Development',
        color: 'red'
      }
    ]
  }
})
